import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatChipEvent as MatChipEvent } from '@angular/material/chips';

export interface ExtentedChip {
  name: string;
  canStar: boolean;
  key?: string;
  starred?: boolean;
  value?: any;
  type?: string;
  backgroundColor?: string;
  isSuggested?: boolean;
  action?: string;
  companylogo?: string;
  continent?: string;
}

@Component({
    selector: 'app-extended-chiplist',
    templateUrl: './extended-chiplist.component.html',
    styleUrls: ['./extended-chiplist.component.scss'],
    standalone: false
})
export class ExtendedChiplistComponent implements OnInit {
  @Input('chips') chips: ExtentedChip[] = [];

  @Output('change') change: EventEmitter<ExtentedChip[]> = new EventEmitter<ExtentedChip[]>();

  constructor() { }

  ngOnInit() {
  }

  toggleStar(chip: ExtentedChip) {
    const c = this.chips.find(c => c.name == chip.name);
    if (c) {
      c.starred = !c.starred;
      c.action = c.starred ? 'starred' : 'unstarred';
      this.updateSelectedTitles();
    }
  }

  removeChip(event: MatChipEvent) {
    const chip = event.chip;
    const extendedChip: ExtentedChip = chip.value;
    if (extendedChip) {
      const index = this.chips.findIndex(t => t.name === extendedChip.name);
      if (index >= 0) {
        this.chips[index].action = 'removed';
        this.updateSelectedTitles();
      }
    }
  }

  private updateSelectedTitles() {
    this.change.emit(this.chips);
  }


}
